<template>
  <section class="ct-products-feed">
    <div class="ct-products-feed__container container">
      <div class="content-type__content">
        <div
          v-if="slice?.Settings?.Title"
          class="content-type__heading heading heading--2"
        >
          <component
            :is="getButtonElement(slice?.Button)"
            :to="slice.Button?.Link"
            :class="slice.Button?.Link ? 'content-type__heading-link' : ''"
          >
            {{ slice.Settings.Title }}
          </component>

          <component
            :is="getButtonElement(slice.Button)"
            v-if="slice.Button"
            :key="slice.Button?.Text"
            class="feed__button button"
            :class="`button--${slice.Button?.Type?.replace('_', '-')}`"
            :to="slice.Button?.Link"
          >
            <IconArrowLeft
              v-if="slice.Button.IconLeft"
              class="icon icon--arrow icon--arrow-left"
            />
            <span>{{ slice.Button?.Text }}</span>
            <IconArrowRight
              v-if="slice.Button.IconRight"
              class="icon icon--arrow icon--arrow-right"
            />
          </component>
        </div>

        <p
          v-if="slice?.Settings?.Description"
          class="content-type__description"
        >
          {{ slice.Settings.Description }}
        </p>

        <ProductSlider
          v-if="slice?.FeedDisplay?.Display === 'Slider'"
          :products="productsData.map((data: any) => data.product)"
          :lazy="index > 0"
          :force-packshot="showPackshot"
        />

        <ul
          v-else-if="slice?.FeedDisplay?.Display === 'Grid'"
          class="ct-products-feed__grid"
        >
          <template
            v-for="(data, i) in productsData"
          >
            <li
              v-if="data.product && data.product?.name"
              :key="data"
              class="ct-products-feed__grid-item"
            >
              <ProductTile
                :product="data.product"
                :lazy="index > 0 || i > 2"
                :force-packshot="showPackshot"
              />
            </li>
          </template>
        </ul>

      <!--  -->
      <!--  -->
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { AppLink } from '#components'

const props = defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
})

const { slice } = toRefs(props)

const getButtonElement = (button) => {
  if (button?.Link) {
    return AppLink
  }

  return 'span'
}

const showPackshot = computed(() => {
  return slice.value?.ForceModel !== true
})

const productsData = computed(() => {
  if (!slice.value?.Products) return []
  return slice.value.Products.filter((data: any) => data?.product && data.product?.name)
})
</script>

<style>
@import url("~layers/app/components/Slices/ProductsFeed.css");
</style>
